export const vendorDocumentsFilter = [
    { id: "gst_certificate", value: "GST Certificate" },
    { id: "pan_card", value: "PAN Card" },
    { id: "bank_details", value: "Bank Details" },
    { id: "product_catalog", value: "Product Catalog" },
    { id: "msme_certificate", value: "MSME Certificate" },
];

export const vendorTypeFilter = [
    { id: "0", value: "Select" },
    { id: "1", value: "Printer" },
    { id: "2", value: "Logistics" },
    { id: "3", value: "Product Supplier" },
];

export const vendorSupplierTypeFilter = [
    { id: "0", value: "Select" },
    { id: "1", value: "Brand" },
    { id: "2", value: "Distributor" },
];

export const vendorStatusFilter = [
    { id: "0", value: "Select" },
    { id: "1", value: "Pending" },
    { id: "2", value: "Approved" },
    { id: "3", value: "Rejected" },
];